export default __webpack_public_path__ + "static/media/icon_menu_changelog.049a6b55.svg";